<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 3H19.3333C20.4379 3 21.3333 3.89543 21.3333 5V19.3333C21.3333 20.4379 20.4379 21.3333 19.3333 21.3333H5C3.89543 21.3333 3 20.4379 3 19.3333V5C3 3.89543 3.89543 3 5 3Z"
      stroke="currentColor"
      stroke-width="2"
    />
    <path
      d="M7.16675 7.16663L17.1667 7.16663"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M17.17 13.3475H9.29565"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.089 15.3366L7.93646 13.3459L11.089 11.3551V15.3366Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
</template>
